// extracted by mini-css-extract-plugin
export default {"root__container":"Confirm_root__container__briDt","root__container__actions":"Confirm_root__container__actions__ezZgO"};